import { QueryClient } from '@tanstack/react-query'

let queryClient: QueryClient

export function getQueryClient() {
    if (queryClient === undefined) {
        queryClient = new QueryClient()
    }

    return queryClient
}
